import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NewsService } from 'src/app/services/news/news.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit,OnDestroy {
  news:any[];
  sub:Subscription[]=[];
  constructor(private newsService:NewsService) { }

  ngOnInit(): void {
    
    this.newsService.getNewsList();
    this.sub[0]= this.newsService.newsList.snapshotChanges().subscribe(
      list=>{
      this.news=  list.map(item=>{  return {
        $key:item.key,
        ... item.payload.val()
      }});
      this.news=this.news.reverse();
      }
      
      );
  }
  
  ngOnDestroy(){
    this.sub.forEach(s=>s.unsubscribe());
  }

}
